<template>
  <h1>Exemplo 2</h1>
</template>

<script>
export default {
  name: "Exemplo2"
};
</script>
